import { axiosClient } from "@/api/axios";

export function getYourLessons(semester) {
  return axiosClient.get(`your-lessons/${semester}`);
}
